import React from 'react';
import { Button, Spinner } from 'reactstrap';
import classnames from 'classnames';

const LoadingButton = ({ children, loading, block, ...rest }) => (
  <Button {...rest} block={block}>
    {!(block && !loading) && (
      <span className="loader-span">
        <Spinner
          className={classnames({
            'btn-loader': !block,
            'd-inline-block': loading,
            'd-none': !loading,
          })}
          size="sm"
        />
      </span>
    )}
    {!(block && loading) && (
      <span
        className={classnames({
          invisible: loading,
          visible: !loading,
          'span-style': !block,
        })}
      >
        {children}
      </span>
    )}
  </Button>
);
export default LoadingButton;
